import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axiosInstance";

export const getGroupTypeApplicationsList = async () => {
  try {
    const response = await axiosInstance.post("api/groups/group-types-users");
    return response?.data;
  } catch (error) {
    return error;
  }
};

export const searchContactsList = async (param: any) => {
  try {
    const response = await axiosInstance.post(
      `api/groups/group-types-users?searchTerm=${param}`,
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

interface PermissionForm {
  specifyPermissionType?: string;
  description: string;
  permission_id?: any;
}

interface PermissionState {
  form: PermissionForm;
}

const initialPermissionForm: PermissionForm = {
  // specifyPermissionType: "",
  description: "",
};

const initialPermissionState: PermissionState = {
  form: initialPermissionForm,
};

export const createPermission = async (
  formData: PermissionForm,
  url: string,
  app_id: string,
) => {
  try {
    const payload = {
      app_id,
      // permission_id: Number(formData?.permission_id),
      permission_name: formData?.specifyPermissionType,
      description: formData?.description,
    };

    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

interface editPermissionayload {
  permission_id: any;
  specifyPermissionType?: string;
  description: string;
}

export const editPermission = async (
  formData: editPermissionayload,
  url: string,
  applicationId: string,
) => {
  try {
    const payload = {
      app_id: applicationId,
      permission_id: Number(formData?.permission_id),
      description: formData?.description,
      permission_name: formData?.specifyPermissionType,
    };
    const response = await axiosInstance.post(url, payload);
    return response?.data;
  } catch (error) {
    throw error;
  }
};

const permissionSlice = createSlice({
  name: "permission",
  initialState: initialPermissionState,
  reducers: {
    setPermissionData(state, action: PayloadAction<Partial<PermissionForm>>) {
      state.form = { ...state.form, ...action.payload };
    },
    resetPermissionData(state) {
      state.form = initialPermissionForm;
    },
  },
});

export const { setPermissionData, resetPermissionData } =
  permissionSlice.actions;
export default permissionSlice.reducer;
